app.factory(
    'Configuration', function (ConfigurationManager) {
        var Configuration = ConfigurationManager.createNewConfiguration();
        // Initial STAGING configuration
        ConfigurationManager.addEnvironmentConfiguration(
            Configuration,
            'staging',
            {
                api: {
                    url: 'http://recette.viaeuropa.com/platformlv/SearchOptimization/core'
                },
                interfaceSubFolder: {
                    url: "/platformlv/SearchOptimization/interface"
                },
                assets: {
                    url: '/www/assets/'
                },
                debug: true
            }
        );
        // Initial PRODUCTION configuration
        ConfigurationManager.addEnvironmentConfiguration(
            Configuration,
            'production',
            {
                api: {
                    url: '//coreapi.content-platform.io'
                },
                interfaceSubFolder: {
                    url: ""
                },
                assets: {
                    url: 'www/assets/'
                },
                debug: true
            }
        );
        ConfigurationManager.loadEnvironment(Configuration, 'staging');
        return Configuration;
    }
);

appexport.factory(
    'Configuration', function (ConfigurationManager) {
        var Configuration = ConfigurationManager.createNewConfiguration();
     
        // Initial STAGING configuration
        ConfigurationManager.addEnvironmentConfiguration(
            Configuration,
            'staging',
            {
                api: {
                    url: 'http://recette.viaeuropa.com/platformlv/DEV-BugsCorrection/core'
                },
                interfaceSubFolder: {
                    url: "/platformlv/DEV-BugsCorrection/interface"
                },
                assets: {
                    url: '/www/assets/'
                },
                debug: true
            }
        );
        // Initial PRODUCTION configuration
        ConfigurationManager.addEnvironmentConfiguration(
            Configuration,
            'production',
            {
                api: {
                    url: '//coreapi.content-platform.io'
                },
                interfaceSubFolder: {
                    url: ""
                },
                assets: {
                    url: 'www/assets/'
                },
                debug: true
            }
        );
        ConfigurationManager.loadEnvironment(Configuration, 'staging');
        return Configuration;
    }
);


app.run(function ($rootScope, $location, $http, HelperService, AdminService, AuthenticationService, UserService, $window) {
    var CommonDataLoaded = false;
    $rootScope.AdminConfiguration = {};
    $rootScope.StatusList4WorkflowDescriptionTranslationName = [];
    $rootScope.StatusList4WorkflowDescriptionTranslationIdValue = [];

    $rootScope.globals = JSON.parse($window.localStorage.getItem('globals'));

    //Delete logged infos if RememberMe was not checked in previous logged-in
    if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.RememberMe == false) {
        localStorage.clear();
        $rootScope.globals = undefined;
    }

    if ($rootScope.globals) {
        //check validity et expiration of local storage
        if ($rootScope.globals.currentUser) {


            $http.defaults.headers.common['Authorization'] = $rootScope.globals.currentUser.AuthenData;
            if ($http.defaults.headers.common['Authorization'] == null) {
                localStorage.clear();
            }
            else {
                if (Math.round(new Date().getTime() / 1000) > $rootScope.globals.expiryTime) {
                    localStorage.clear();
                }
            }
        }
        else {
            localStorage.clear();
        }
    }
    else {
        localStorage.clear();
    }

    $rootScope.$on('$locationChangeStart', function (event, next, current) {
        $rootScope.globals = JSON.parse($window.localStorage.getItem('globals'));
        var restrictedPage = $.inArray($location.path(), ['', '/login', '/register', '/resetpasswordvalidateemail', '/resetpassword', '/createpassword', '/shareurl', '/mentionslegales']) === -1;


        updateReturnUrl = function (next, current) {

            if (restrictedPage) {
                if (!next.includes('login') && !next.includes('resetpasswordvalidateemail') && !next.includes('resetpassword') && !next.includes('createpassword') && !next.includes('mentionslegales')) {
                    $rootScope.returnUrlAfterLogin = next;
                    $location.search({});
                    $location.path('/login');
                }
                else {
                    if (!current.includes('login') && !current.includes('resetpasswordvalidateemail') && !current.includes('resetpassword') && !current.includes('createpassword') && current.includes('mentionslegales')) {
                        $rootScope.returnUrlAfterLogin = current;
                        $location.search({});
                        $location.path('/login');
                    }
                }

            }
        }

        var loggedIn = undefined;
        if ($rootScope.globals) {
            loggedIn = $rootScope.globals.currentUser;
            if (Math.round(new Date().getTime() / 1000) > $rootScope.globals.expiryTime) {
                //logging session expired
                updateReturnUrl(next, current);
            }
        }
        else {
            //not logged in
            updateReturnUrl(next, current);
        }

        if (loggedIn === undefined || loggedIn.AppVersion === undefined || loggedIn.AppVersion != appVersion) {
            if (loggedIn && (loggedIn.AppVersion === undefined || loggedIn.AppVersion != appVersion)) {
                $location.search({});
                $location.path('/login');
            }

            else {
                if (restrictedPage && !loggedIn) {
                    $location.search({});
                    $location.path('/login');
                }
            }
        }
        else {
            if (!CommonDataLoaded && (loggedIn !== undefined)) {
                HelperService.GetWorkflowStatusList($rootScope.globals.currentUser.LangForInterface)
                    .then(function (helperVm) {
                        $rootScope.StatusList4WorkflowObject = helperVm.StatusList4WorkflowObject;
                        $rootScope.StatusList4WorkflowObjectSt = helperVm.StatusList4WorkflowObjectSt;

                        $rootScope.StatusList4WorkflowDescription = helperVm.StatusList4WorkflowDescription;
                        $rootScope.StatusList4WorkflowDescriptionSt = helperVm.StatusList4WorkflowDescriptionSt;

                        $rootScope.StatusList4WorkflowDescriptionTranslation = helperVm.StatusList4WorkflowDescriptionTranslation;
                        $rootScope.StatusList4WorkflowDescriptionTranslationSt = helperVm.StatusList4WorkflowDescriptionTranslationSt;

                        var l = $rootScope.StatusList4WorkflowDescriptionTranslationSt.length;
                        for (var i = 0; i < l; i++) {
                            $rootScope.StatusList4WorkflowDescriptionTranslationName.push($rootScope.StatusList4WorkflowDescriptionTranslationSt[i].StatusTitle);
                            $rootScope.StatusList4WorkflowDescriptionTranslationIdValue.push({ 'id': $rootScope.StatusList4WorkflowDescriptionTranslationSt[i].StatusId, 'value': $rootScope.StatusList4WorkflowDescriptionTranslationSt[i].StatusTitle });
                        }
                    });

                AdminService.getAdminGeneralInfo()
                    .then(function (res) {

                        $rootScope.AdminConfiguration.ckEditorStyleSheet = JSON.parse(res.data.ckEditorStyleSheetGeneral);
                        $rootScope.AdminConfiguration.LengthLimitOfDescInPlace = res.data.LengthLimitOfDescInPlace;

                        $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary6560 = res.data.LengthLimitOfDescInItinerary6560;
                        $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary10588 = res.data.LengthLimitOfDescInItinerary10588;

                        $rootScope.AdminConfiguration.LengthLimitOfDescInBio = res.data.LengthLimitOfDescInBio;
                        $rootScope.AdminConfiguration.LengthLimitOfDescInDistrict = res.data.LengthLimitOfDescInDistrict;

                        $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10584 = res.data.LengthLimitOfDescInGroup10584;
                        $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10585 = res.data.LengthLimitOfDescInGroup10585;
                        $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10586 = res.data.LengthLimitOfDescInGroup10586;

                        CKEDITOR.stylesSet.add('attributeStyleSet', $rootScope.AdminConfiguration.ckEditorStyleSheet);
                        CKEDITOR.config.autoParagraph = false;
                    });

                CommonDataLoaded = true;
            }
        }
    });

});


appexport.run(function ($rootScope, $location, $http, $window) {
    var CommonDataLoaded = false;
    $rootScope.AdminConfiguration = {};
    $rootScope.StatusList4WorkflowDescriptionTranslationName = [];
    $rootScope.StatusList4WorkflowDescriptionTranslationIdValue = [];

    $rootScope.globals = JSON.parse($window.localStorage.getItem('globals'));

    //Delete logged infos if RememberMe was not checked in previous logged-in
    if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.RememberMe == false) {
        localStorage.clear();
        $rootScope.globals = undefined;
    }

    if ($rootScope.globals) {
        //check validity et expiration of local storage
        if ($rootScope.globals.currentUser) {

            $http.defaults.headers.common['Authorization'] = $rootScope.globals.currentUser.AuthenData;
            if ($http.defaults.headers.common['Authorization'] == null) {
                localStorage.clear();
            }
            else {
                if (Math.round(new Date().getTime() / 1000) > $rootScope.globals.expiryTime) {
                    localStorage.clear();
                }
            }
        }
        else {
            localStorage.clear();
        }
    }
    else {
        localStorage.clear();
    }

    $rootScope.$on('$locationChangeStart', function (event, next, current) {
        $rootScope.globals = JSON.parse($window.localStorage.getItem('globals'));
        var restrictedPage = $.inArray($location.path(), ['', '/login', '/register', '/resetpasswordvalidateemail', '/resetpassword', '/createpassword', '/shareurl', '/mentionslegales']) === -1;

        updateReturnUrl = function (next, current) {

            if (restrictedPage) {
                if (!next.includes('login') && !next.includes('resetpasswordvalidateemail') && !next.includes('resetpassword') && !next.includes('createpassword') && !next.includes('mentionslegales')) {
                    $rootScope.returnUrlAfterLogin = next;
                    $location.search({});
                    $location.path('/login');
                }
                else {
                    if (!current.includes('login') && !current.includes('resetpasswordvalidateemail') && !current.includes('resetpassword') && !current.includes('createpassword') && current.includes('mentionslegales')) {
                        $rootScope.returnUrlAfterLogin = current;
                        $location.search({});
                        $location.path('/login');
                    }
                }

            }
        }

        var loggedIn = undefined;
        if ($rootScope.globals) {
            loggedIn = $rootScope.globals.currentUser;
            if (Math.round(new Date().getTime() / 1000) > $rootScope.globals.expiryTime) {
                //logging session expired
                updateReturnUrl(next, current);
            }
        }
        else {
            //not logged in
            updateReturnUrl(next, current);
        }
    });
});

